const getVideoSourceFormats = () => ['mp4'];

export default getVideoSourceFormats;
